module.exports = __webpack_public_path__ + "img/logo_khy.e03afa66.png";